import { render } from "./slidecrown-4.vue?vue&type=template&id=3acc2c59&scoped=true"
import script from "./slidecrown-4.vue?vue&type=script&lang=js"
export * from "./slidecrown-4.vue?vue&type=script&lang=js"

import "./slidecrown-4.vue?vue&type=style&index=0&id=3acc2c59&class=scss&scoped=true&lang=css"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acc2c59"]])

export default __exports__